
import { z } from "zod";

export const SmsStatusValues = ["ACCEPTED", "CANCELED", "DELIVERED", "FAILED", "QUEUED", "READ", "RECEIVED", "SCHEDULED", "SENT", "UNDELIVERED"] as const;
export const SmsStatusSchema = z.enum(SmsStatusValues);
export const SmsStatus = SmsStatusSchema.enum;
export type SmsStatus = (typeof SmsStatusValues)[number];
export const SmsStatusDisplayNames = { "ACCEPTED": "Accepted",
"CANCELED": "Canceled",
"DELIVERED": "Delivered",
"FAILED": "Failed",
"QUEUED": "Queued",
"READ": "Read",
"RECEIVED": "Received",
"SCHEDULED": "Scheduled",
"SENT": "Sent",
"UNDELIVERED": "Undelivered", } satisfies Record<SmsStatus, string>;
